import combineImmutableReducers from './combineImmutableReducers';
import globalReducer from './global';
import toastReducer from './toast';

const createAppReducer = () =>
  combineImmutableReducers({
    global: globalReducer,
    toast: toastReducer,
  });

export const createRootReducer = () =>
  combineImmutableReducers({ app: createAppReducer() });
